import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import bedManagement from './locales/fr/bed-management.json';
import environmentalCleaning from './locales/fr/environmental-cleaning.json';
import common from './locales/fr/common.json';
import patientTransport from './locales/fr/patient-transport.json';

i18next.use(initReactI18next).init({
  lng: 'fr',
  ns: ['common', 'patient-transport', 'bed-management', 'environmental-cleaning'],
  defaultNS: 'common',
  fallbackNS: 'common',
  resources: {
    fr: {
      common,
      'patient-transport': patientTransport,
      'bed-management': bedManagement,
      'environmental-cleaning': environmentalCleaning,
    },
  },
});

export default i18next;
